export const META_ATTACH_VIEW_NONE = 'META_ATTACH_VIEW_NONE';
export const META_ATTACH_VIEW_MASS_ADD = 'META_ATTACH_VIEW_MASS_ADD';
export const META_ATTACH_VIEW_POPULATE = 'META_ATTACH_VIEW_POPULATE';
export const META_ATTACH_VIEW_COPY = 'META_ATTACH_VIEW_COPY';

// i.e. when attaching is in progress
export const META_ATTACH_STATE_FETCHING_DATA = 'META_ATTACH_STATE_FETCHING_DATA';
export const META_ATTACH_STATE_READY = 'META_ATTACH_STATE_READY';
export const META_ATTACH_STATE_IN_PROGRESS = 'META_ATTACH_STATE_IN_PROGRESS';
export const META_ATTACH_STATE_SUCCESS = 'META_ATTACH_STATE_SUCCESS';
export const META_ATTACH_STATE_FAILURE = 'META_ATTACH_STATE_FAILURE';

export const META_COPY_STATE_IN_PROGRESS = 'META_COPY_STATE_IN_PROGRESS';
export const META_COPY_STATE_SUCCESS = 'META_COPY_STATE_SUCCESS';
export const META_COPY_STATE_FAILURE = 'META_COPY_STATE_FAILURE';
